module.exports = __webpack_public_path__ + "img/gaolou.701f7b15.png";